import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function TopNav(){
    const navigate = useNavigate();
    
    return (
        <div className="nav-header">
            <a href="index.php" className="brand-logo mt-30">
                <img src="../assets/images/oatek_logo2.png" alt="" />
            </a>

            <div className="nav-control">
                <div className="hamburger">
                    <span className="line"></span><span className="line"></span><span className="line"></span>
                </div>
            </div>
        </div>

    );
}